import * as React from 'react';
import { SystemEventLevel } from 'bernie-logger';
import { useHistory, useLocation } from 'react-router-dom';

import { FlightsSortAndFilters } from '@shared-ui/retail-sort-and-filter-flights';

import { useSortAndFilterInput, useStores } from 'utility/hooks';
import { onFilterPillSelect } from 'experiments/PWA_USF_FSR/usf-utils';
import { logEvent } from './utils';
import { SortAndFiltersViewType } from 'types/search/sort-filter';

export const UniversalFilterPills = () => {
  const { context, searchCriteriaStore } = useStores();
  const location = useLocation();
  const history = useHistory();
  const sortAndFilterInput = useSortAndFilterInput();

  const handleOnFieldChange = React.useCallback(
    (field, event) => {
      const displayToast = searchCriteriaStore.hasSmartShoppingFastFollowCriteria && event.currentTarget.checked;

      return onFilterPillSelect(field, event, searchCriteriaStore, context, history, location, displayToast);
    },
    [searchCriteriaStore, context, history, location]
  );

  const onEmptyResults = React.useCallback(() => {
    logEvent(
      SystemEventLevel.ERROR,
      'SMART_SHOPPING_FSR_FILTER_PILLS_ERROR',
      'smart shopping filter pills on FSR not rendered'
    );
  }, []);

  if (!searchCriteriaStore?.searchCriteria?.journeyCriteria[0].departureDate.day) {
    return null;
  }

  return (
    <FlightsSortAndFilters
      onFieldChange={handleOnFieldChange}
      view={SortAndFiltersViewType.FILTERS_PILLS}
      inputs={sortAndFilterInput}
      onEmptyResults={onEmptyResults}
    />
  );
};
